import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { RequestAccessSettingModel } from './request-access-setting.model';

@Injectable()
export class RequestAccessSettingService {
    constructor(private fiBackend: FiBackendService) {}

    getRequestAccessSetting() {
        return this.fiBackend.fetchObject('Core/RequestAccess/GetRequestAccessSetting', RequestAccessSettingModel);
    }

    saveRequestAccessSetting(setting) {
        return this.fiBackend.fetchDataPost('Core/RequestAccess/SaveRequestAccessSetting', setting);
    }
}
